import { useNavigate } from 'react-router-dom';
import { RunSearchList } from './RunSearchList';
import { SiteHeader } from '@/components/site-header';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export function RunSearchDashboard() {
    const navigate = useNavigate();

    const handleBackToWorkflows = () => {
        navigate('/dashboard/workflows');
    };

    return (
        <>
            <SiteHeader 
                title="Runs Search"
                subtitle="Search and filter workflow runs with advanced queries"
                backButton={
                    <Button
                        variant="ghost"
                        size="sm"
                        onClick={handleBackToWorkflows}
                        className="gap-2"
                    >
                        <ArrowLeft className="h-4 w-4" />
                        Back
                    </Button>
                }
            />
            <RunSearchList />
        </>
    );
}
